import { IMG } from "../data/site";
import { PageHero, Section } from "../components/site/bits";

function Prose({ blocks }) {
  return (
    <Section>
      <div className="mx-auto max-w-3xl space-y-10">
        {blocks.map((b, i) => (
          <div key={i}>
            <h2 className="font-serif text-2xl text-brand-dark md:text-3xl">{b.h}</h2>
            <p className="mt-4 text-brand-slate">{b.p}</p>
          </div>
        ))}
      </div>
    </Section>
  );
}

export function Privacy() {
  return (
    <>
      <PageHero overline="Legal" lines={["Privacy Policy"]} image={IMG.office}
        intro="How Shelterease Housing Association collects, uses and protects your personal information." />
      <Prose blocks={[
        { h: "Who we are", p: "Shelterease Housing Association is the data controller for the personal information we hold. We are committed to protecting your privacy in line with UK GDPR and the Data Protection Act 2018." },
        { h: "Information we collect", p: "We collect information you provide through our enquiry, referral, landlord, volunteer and contact forms, including your name, contact details and the details of any enquiry or referral you make." },
        { h: "How we use it", p: "We use your information to respond to enquiries, process referrals, deliver support services, manage tenancies and improve our services. We never sell your data." },
        { h: "Lawful basis", p: "We process personal data on the basis of consent, legitimate interest, contract and, where relevant, our public task in delivering supported accommodation." },
        { h: "Your rights", p: "You have the right to access, correct, erase or restrict the use of your data, and to withdraw consent at any time. Contact info@shelterease.org.uk to exercise these rights." },
        { h: "Cookies", p: "We use essential and analytics cookies to operate and improve the website. You can manage your preferences via the cookie banner." },
      ]} />
    </>
  );
}

export function Accessibility() {
  return (
    <>
      <PageHero overline="Legal" lines={["Accessibility", "Statement"]} image={IMG.community}
        intro="We want everyone to be able to use our website, whatever their needs or abilities." />
      <Prose blocks={[
        { h: "Our commitment", p: "We are committed to making our website accessible in accordance with the Web Content Accessibility Guidelines (WCAG) 2.1 AA standard." },
        { h: "What we do", p: "We use clear language, sufficient colour contrast, keyboard-navigable components, descriptive text alternatives for images, and respect reduced-motion preferences." },
        { h: "Language support", p: "A language selector offers commonly spoken refugee languages, and our team can arrange interpretation and translated materials on request." },
        { h: "Feedback", p: "If you experience any difficulty using this website, please contact us at info@shelterease.org.uk or call 024 7699 5724 and we will do our best to help." },
      ]} />
    </>
  );
}
